













































export default function (Component) {
  Component.options.__source = "src/components/Hamburger/index.vue"
}
